import { connectWithHammock, ENDPOINTS } from 'hammock';
import React, { useMemo } from 'react';

import { CollectionTargetLocation } from 'craft/types';

import { FieldEditor } from './FieldEditor';
import { FieldsEditorWrapper } from './StyledComponents';
import { FieldsEditorProps } from './types';

export const FieldsEditorImpl = ({
  collectionsMetadata,
  nodeIds,
  collectionId,
  collectionEmbedLocations,
  collections,
  type,
  setCustom,
  setProps,
  isPopover,
}: FieldsEditorProps) => {
  const usedCollection = useMemo(() => collectionsMetadata.find((c) => c.id === collectionId), [
    collectionId,
    collectionsMetadata,
  ]);

  return (
    <FieldsEditorWrapper isPopover={isPopover}>
      {Object.keys(collectionEmbedLocations).map((targetLocation) => {
        const embedLocations = collectionEmbedLocations[targetLocation as CollectionTargetLocation];
        if (embedLocations && embedLocations.length !== 0) {
          return (
            <FieldEditor
              key={`field-${targetLocation}`}
              context={{ isPopover }}
              nodeIds={nodeIds}
              type={type}
              collections={collections}
              usedCollection={usedCollection}
              targetLocation={targetLocation as CollectionTargetLocation}
              setCustom={setCustom}
              setProps={setProps}
              collectionEmbedLocations={embedLocations}
            />
          );
        }
        return null;
      })}
    </FieldsEditorWrapper>
  );
};

export const FieldsEditor = connectWithHammock({
  endpoint: ENDPOINTS.collections,
  resourceName: 'collectionsMetadata',
})(FieldsEditorImpl);
